export default {"src":"/_next/static/image/public/images/flags/flag_420.7a9b928c78b97ce7ab8dc1420e8086f4.svg","height":16,"width":24};